/* eslint-disable camelcase */
import { Subscription } from '../../domain/backoffice/subscription/Subscription';
import { SubscriptionDTO } from '../../domain/backoffice/subscription/SubscriptionDTO';

export class SubscriptionMapper {
  static toDomain(props: SubscriptionDTO): Subscription {
    const {
      updated_at,
      stripe_customer_id,
      stripe_subscription_id,
      stripe_payment_token,
      pipedrive_person_id,
      plan,
      billing_period,
      current_period_end,
      scheduled_update,
      will_cancel,
      status,
      tax_percent,
      card,
      coupon,
      billing_info,

      client_secret,
      emails,
      sms,
      whatsapp,
      geocode_credit,

      traffic,

      has_contract,

      vehicles,
      users,
      projects,
      supervisors,

      extra_vehicles,
      extra_users,
      extra_projects,
      extra_supervisors,
    } = props;

    return Subscription.create({
      updated_at: updated_at,

      stripe_customer_id: stripe_customer_id,
      stripe_subscription_id: stripe_subscription_id,
      stripe_payment_token: stripe_payment_token,
      pipedrive_person_id: pipedrive_person_id,

      plan: plan,
      billing_period: billing_period,

      current_period_end: current_period_end,
      scheduled_update: scheduled_update,
      will_cancel: will_cancel,

      status: status,
      tax_percent: tax_percent,
      card: card
        ? {
            stripe_id: card.stripe_id,
            brand: card.brand,
            fingerprint: card.fingerprint,
            funding: card.funding,
            name: card.name,
            address_line1: card.address_line1,
            address_line2: card.address_line2,
            address_city: card.address_city,
            address_country: card.address_country,
            address_state: card.address_state,
            address_zip: card.address_zip,
            last4: card.last4,
            exp_month: card.exp_month,
            exp_year: card.exp_year,
          }
        : undefined,
      coupon: coupon,
      billing_info: billing_info
        ? {
            name: billing_info.name,
            city: billing_info.city,
            country: billing_info.country,
            line1: billing_info.line1,
            line2: billing_info.line2 ?? undefined,
            postal_code: billing_info.postal_code ?? undefined,
            state: billing_info.state ?? undefined,
            tax_value: billing_info.tax_value ?? undefined,
            tax_id: billing_info.tax_id ?? undefined,
          }
        : undefined,
      client_secret: client_secret,
      emails: {
        period_usage: emails.period_usage,
        extended_limit: emails.extended_limit,
      },
      sms: {
        enabled: sms.enabled,
        credit: sms.credit,
        auto_recharge: sms.auto_recharge,
        auto_recharge_at: sms.auto_recharge_at,
        auto_recharge_amount: sms.auto_recharge_amount,
        auto_recharge_price: sms.auto_recharge_price,
      },
      whatsapp: {
        enabled: whatsapp.enabled,
        credit: whatsapp.credit,
      },
      geocode_credit,

      traffic,

      has_contract,

      vehicles,
      users,
      projects,
      supervisors,

      extra_vehicles,
      extra_users,
      extra_projects,
      extra_supervisors,
    });
  }
}
